// @ts-nocheck
"use client";

import clsx from "clsx";
import DOMPurify from "dompurify";
import { useEffect, useRef, useState } from "react";
import styles from "./description.module.css";
import { getSignedUrl, useSignedUrl } from "../../utils/useSignedUrl";
import { FaCheck } from "react-icons/fa6";
import Slider from "./slider";

import { createRoot } from 'react-dom/client';
import dynamic from "next/dynamic";
import { disallowSharingInfo } from "../../lib/gtm";
import CCPAForm from "./ccpa-form";
import Modal from "./modal";
import Loader from "../loader/loader";
import { useTheme } from "../../utils/theme";

const VideoEmbed = dynamic(() => import("./video-embed"), { ssr: false });
const CCPAEmbed = dynamic(() => import("./ccpa"), { ssr: false });

export default function Description({ description, width = 100, classStyle = "titles-h2", mode = "", openModal = undefined, lightMode = false, forceColor = null }) {
    const [sanitizedDescription, setSanitizedDescription] = useState("");
    const { theme } = useTheme();
    // Use passed lightMode prop if explicitly set, otherwise fall back to theme
    const resolvedLightMode = lightMode !== false ? lightMode : theme === "light";
    const hasForceColor = typeof forceColor === "string" && forceColor.trim().length > 0;

    useEffect(() => {
        if (description) {
            let sanitized = DOMPurify.sanitize(description, {
                ADD_TAGS: ['ccpa', 'embedVideo', 'ccpaform']
            });
            let tempDiv = document.createElement("div");
            tempDiv.innerHTML = sanitized;

            const processImages = async () => {
                const imgElements = tempDiv.querySelectorAll("img");

                for (const img of imgElements) {
                    const src = img.src;
                    if (!src) continue;

                    try {
                        const signedUrl = await getSignedUrl(src);

                        if (signedUrl) {
                            img.setAttribute("src", signedUrl); // Replace the src with signed URL
                        }
                    } catch (e) {
                        // Error handling
                    }
                }

                setSanitizedDescription(tempDiv.innerHTML);
                setTimeout(() => {
                    const ccpaDivs = document.querySelectorAll("[id^='ccpa-embed-']");
                    
                    ccpaDivs.forEach((el) => {
                        const text = el.getAttribute("data-ccpa-text");

                        if (text && !el.hasAttribute("data-mounted")) {
                            const root = createRoot(el);
                            root.render(<CCPAEmbed text={text} />);
                            el.setAttribute("data-mounted", "true");
                        }
                    });
                }, 50);
                setTimeout(() => {
                    const ccpaDivs = document.querySelectorAll("[id^='ccpa-form-embed-']");
                    
                    ccpaDivs.forEach((el) => {
                        const text = el.getAttribute("data-ccpa-text");

                        if (text && !el.hasAttribute("data-mounted")) {
                            const root = createRoot(el);
                            root.render(<CCPAForm text={text} openModal={openModal} />);
                            el.setAttribute("data-mounted", "true");
                        }
                    });
                }, 100);

                setTimeout(() => {
                    const embedVids = document.querySelectorAll("[id^='video-embed-']");
                    embedVids.forEach((ev) => {
                        const url = ev.getAttribute("data-video-url");
                        if (url && !ev.hasAttribute("data-mounted")) {
                            const root = createRoot(ev);
                            root.render(<VideoEmbed url={url} />);
                            ev.setAttribute("data-mounted", "true");
                        }
                    });
                }, 150);
            };

            if (mode === 'blog') {
                // tempDiv.querySelectorAll("embedVideo").forEach((videoTag) => {
                //     const url = videoTag.textContent.trim();
                //     let embedUrl = "";

                //     if (url.includes("youtube.com") || url.includes("youtu.be")) {
                //         const videoId = url.includes("youtu.be")
                //             ? url.split("youtu.be/")[1].split("?")[0]
                //             : new URL(url).searchParams.get("v");
                //         embedUrl = `https://www.youtube.com/embed/${videoId}`;
                //     } else if (url.includes("vimeo.com")) {
                //         const videoId = url.split("vimeo.com/")[1].split("?")[0];
                //         embedUrl = `https://player.vimeo.com/video/${videoId}`;
                //     }

                //     if (embedUrl) {
                //         // Create a responsive wrapper
                //         const wrapper = document.createElement("div");
                //         wrapper.style.position = "relative";
                //         wrapper.style.width = "100%";
                //         wrapper.style.paddingBottom = "56.25%"; // 16:9 aspect ratio
                //         wrapper.style.height = "0";
                //         wrapper.style.overflow = "hidden";
                //         wrapper.style.zIndex = "1";

                //         const iframe = document.createElement("iframe");
                //         iframe.setAttribute("src", embedUrl);
                //         iframe.setAttribute("frameborder", "0");
                //         iframe.setAttribute("allowfullscreen", "true");
                //         iframe.setAttribute("loading", "eager"); // prevent lazy load flicker
                //         iframe.setAttribute(
                //             "allow",
                //             "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                //         );

                //         // Inline responsive iframe styles with GPU-acceleration fixes
                //         iframe.style.position = "absolute";
                //         iframe.style.top = "0";
                //         iframe.style.left = "0";
                //         iframe.style.width = "100%";
                //         iframe.style.height = "100%";
                //         iframe.style.border = "none";
                //         iframe.style.transform = "translateZ(0)";
                //         iframe.style.backfaceVisibility = "hidden";

                //         wrapper.appendChild(iframe);
                //         videoTag.replaceWith(wrapper);
                //     }
                // });

                tempDiv.querySelectorAll("ccpa").forEach((ccpaTag, index) => {
                    const text = ccpaTag.textContent.trim();
                    const placeholderId = `ccpa-embed-${index}`;

                    const div = document.createElement("div");
                    div.setAttribute("id", placeholderId);
                    div.setAttribute("data-ccpa-text", text);
                    div.style.width = "100%";
                    div.style.margin = "1rem 0";

                    ccpaTag.replaceWith(div);
                });

                tempDiv.querySelectorAll("ccpaform").forEach((ccpaTag, index) => {
                    const text = ccpaTag.textContent.trim();
                    const placeholderId = `ccpa-form-embed-${index}`;

                    const div = document.createElement("div");
                    div.setAttribute("id", placeholderId);
                    div.setAttribute("data-ccpa-text", text);
                    div.style.width = "100%";
                    div.style.margin = "1rem 0";

                    ccpaTag.replaceWith(div);
                });

                tempDiv.querySelectorAll("embedVideo").forEach((videoTag, index) => {
                    const url = videoTag.textContent.trim();
                    const placeholderId = `video-embed-${index}`;

                    const div = document.createElement("div");
                    div.setAttribute("id", placeholderId);
                    div.setAttribute("data-video-url", url);
                    div.style.width = "100%";
                    div.style.margin = "1rem 0";

                    videoTag.replaceWith(div);
                });

                tempDiv.querySelectorAll("ol").forEach((ol) => {
                    let startIndex = parseInt(ol.getAttribute("start")) || 1;
                    ol.querySelectorAll("li").forEach((li, index) => {
                        let numberSpan = document.createElement("span");
                        numberSpan.textContent = startIndex + index;
                        li.prepend(numberSpan);
                    });
                });

                tempDiv.querySelectorAll("ul").forEach((ul) => {
                    ul.querySelectorAll("li").forEach((li) => {
                        // Skip if the closest parent list is an <ol>
                        let parentList = li.closest("ul, ol");
                        if (parentList.tagName.toLowerCase() !== "ul") return;

                        // Only proceed if this <li> is directly under a <ul>
                        let span = document.createElement("span");
                        span.innerHTML = `
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24" height="24">
                                <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204
                                    c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997
                                    36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207
                                    9.997-36.204-.001z"></path>
                            </svg>
                        `;
                        span.style.display = "flex";
                        span.style.alignItems = "center";
                        span.style.justifyContent = "center";
                        span.style.height = "15px";
                        span.style.aspectRatio = "1";
                        span.style.position = "absolute";
                        span.style.left = "5px";
                        span.style.fill = "#FF6d10";

                        li.style.paddingLeft = "50px";
                        li.prepend(span);
                    });
                });

                tempDiv.querySelectorAll("ul li ol").forEach((nestedOl) => {
                    nestedOl.style.paddingTop = "14px";
                });

                tempDiv.querySelectorAll("blockquote").forEach((blockquote) => {
                    let p = blockquote.querySelector("p");
                    if (!p) {
                        p = document.createElement("p");
                        p.innerHTML = blockquote.innerHTML;
                        blockquote.innerHTML = "";
                        blockquote.appendChild(p);
                    }

                    let openQuote = document.createElement("span");
                    openQuote.innerHTML = `<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                                viewBox="0 0 32 32" xml:space="preserve">
                            <g>
                                <g id="right_x5F_quote">
                                    <g>
                                        <path d="M0,4v12h8c0,4.41-3.586,8-8,8v4c6.617,0,12-5.383,12-12V4H0z"/>
                                        <path d="M20,4v12h8c0,4.41-3.586,8-8,8v4c6.617,0,12-5.383,12-12V4H20z"/>
                                    </g>
                                </g>
                            </g>
                        </svg>`;
                    openQuote.style.marginRight = "8px";
                    p.prepend(openQuote);
                });
            }
            // console.log("before processin")
            // ✅ Start image processing AFTER content formatting
            processImages();
        }
    }, [description]);

    return (
        <>
            {description && (
                <div
                    dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                    className={clsx(classStyle, { [styles.desc]: classStyle === "titles-h2", [styles.light]: resolvedLightMode && !hasForceColor, [styles.forced]: hasForceColor })}
                    // className={clsx(classStyle, "titles-h2" )}
                    style={{ width: `${width}%`, ...(hasForceColor ? { "--force-color": forceColor } : {}) }}
                />
            )}
        </>
    );

}

// // @ts-nocheck
// "use client";

// import clsx from "clsx";
// import DOMPurify from "dompurify";
// import { useEffect, useState } from "react";
// import styles from "./description.module.css";
// import { getSignedUrl } from "../../utils/useSignedUrl";
// import dynamic from "next/dynamic";
// import { createRoot } from "react-dom/client"; // ✅ use this instead of ReactDOM.render

// const VideoEmbed = dynamic(() => import("./video-embed"), { ssr: false });

// export default function Description({
//     description,
//     width = 100,
//     classStyle = "titles-h2",
//     mode = "",
// }) {
//     const [sanitizedDescription, setSanitizedDescription] = useState("");

//     useEffect(() => {
//         if (!description) return;

//         const tempDiv = document.createElement("div");
//         tempDiv.innerHTML = description;

//         if (mode === "blog") {
//             tempDiv.querySelectorAll("ccpa").forEach((ccpa) => {
//                 const newDiv = document.createElement("label");
//                 const checkbox = document.createElement("input");
//                 checkbox.type = "checkbox";
//                 const text = document.createTextNode(" " + ccpa.textContent.trim());
//                 newDiv.appendChild(checkbox);
//                 newDiv.appendChild(text);
//                 ccpa.replaceWith(newDiv);
//             });

//             tempDiv.querySelectorAll("embedVideo").forEach((videoTag, index) => {
//                 const url = videoTag.textContent.trim();
//                 const placeholderId = `video-embed-${index}`;

//                 const div = document.createElement("div");
//                 div.setAttribute("id", placeholderId);
//                 div.setAttribute("data-video-url", url);
//                 div.style.width = "100%";
//                 div.style.margin = "1rem 0";

//                 videoTag.replaceWith(div);
//             });

//             tempDiv.querySelectorAll("ol").forEach((ol) => {
//                 const startIndex = parseInt(ol.getAttribute("start")) || 1;
//                 ol.querySelectorAll("li").forEach((li, index) => {
//                     const numberSpan = document.createElement("span");
//                     numberSpan.textContent = startIndex + index;
//                     li.prepend(numberSpan);
//                 });
//             });

//             tempDiv.querySelectorAll("ul").forEach((ul) => {
//                 ul.querySelectorAll("li").forEach((li) => {
//                     const span = document.createElement("span");
//                     span.innerHTML = `
//                         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24" height="24">
//                             <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204
//                                 c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997
//                                 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207
//                                 9.997-36.204-.001z"></path>
//                         </svg>
//                     `;
//                     span.style.display = "flex";
//                     span.style.alignItems = "center";
//                     span.style.justifyContent = "center";
//                     span.style.height = "15px";
//                     span.style.aspectRatio = "1";
//                     span.style.position = "absolute";
//                     span.style.left = "5px";
//                     span.style.fill = "#FF6d10";
//                     li.style.paddingLeft = "50px";
//                     li.prepend(span);
//                 });
//             });

//             tempDiv.querySelectorAll("blockquote").forEach((blockquote) => {
//                 let p = blockquote.querySelector("p");
//                 if (!p) {
//                     p = document.createElement("p");
//                     p.innerHTML = blockquote.innerHTML;
//                     blockquote.innerHTML = "";
//                     blockquote.appendChild(p);
//                 }

//                 const openQuote = document.createElement("span");
//                 openQuote.innerHTML = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg"
//                         viewBox="0 0 32 32">
//                     <g><path d="M0,4v12h8c0,4.41-3.586,8-8,8v4c6.617,0,12-5.383,12-12V4H0z"/>
//                     <path d="M20,4v12h8c0,4.41-3.586,8-8,8v4c6.617,0,12-5.383,12-12V4H20z"/></g>`;
//                 openQuote.style.marginRight = "8px";
//                 p.prepend(openQuote);
//             });
//         }

//         const cleanHTML = DOMPurify.sanitize(tempDiv.innerHTML, {
//             ADD_TAGS: ["iframe", "svg", "path"],
//             ADD_ATTR: [
//                 "allow",
//                 "allowfullscreen",
//                 "frameborder",
//                 "scrolling",
//                 "loading",
//                 "data-video-url",
//                 "id",
//             ],
//         });

//         const finalDiv = document.createElement("div");
//         finalDiv.innerHTML = cleanHTML;

//         const processImages = async () => {
//             const imgElements = finalDiv.querySelectorAll("img");
//             for (const img of imgElements) {
//                 const src = img.src;
//                 if (!src) continue;
//                 try {
//                     const signedUrl = await getSignedUrl(src);
//                     if (signedUrl) img.setAttribute("src", signedUrl);
//                 } catch (e) {
//                     console.warn("Image signing failed", e);
//                 }
//             }

//             setSanitizedDescription(finalDiv.innerHTML);
//         };

//         processImages();
//     }, [description, mode]);

//     useEffect(() => {
//         console.log("change!");
//         if (!sanitizedDescription) return;
//         const timeout = setTimeout(() => {
//             const embedDivs = document.querySelectorAll("[id^='video-embed-']");
//             embedDivs.forEach((el) => {
//                 const url = el.getAttribute("data-video-url");
//                 if (url) {
//                     const root = createRoot(el); // ✅ Create React root
//                     root.render(<VideoEmbed url={url} />);
//                 }
//             });
//         }, 50);

//         return () => clearTimeout(timeout);
//     }, [sanitizedDescription]);

//     return (
//         <>
//             {description && (
//                 <div
//                     dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
//                     className={clsx(classStyle, {
//                         [styles.desc]: classStyle === "titles-h2",
//                     })}
//                     style={{ width: `${width}%` }}
//                 />
//             )}
//         </>
//     );
// }

